enum OnboardingSteps {
  SET_DETAILS = "step.set_details",
  SET_PASSWORD = "step.set_password",
  ACCEPT_GDPR = "step.accept_gdpr",
  HAS_VIEWED_MEDICAL_ACTIVATION_PAGE = "step.hasViewedMedicalActivationPage",
  HAS_HIDDEN_MEDICAL_ACTIVATION_PAGE = "step.hasHiddenMedicalActivationPageTooltip",
  HAS_VIEWED_MEDICAL_GET_STARTED_PAGE = "step.hasViewedMedicalGetStartedPage",
  HAS_HIDDEN_MEDICAL_GET_STARTED_PAGE = "step.hasHiddenMedicalGetStartedTooltip",
  HAS_COMPLETED_HOMEPAGE_TOUR = "step.hasCompletedHomepageTour",
  HAS_VIEWED_TENANT_SETUP_PRE_TOUR = "step.hasViewedTenantSetupPreTour",
  HAS_COMPLETED_TENANT_SETUP_TOUR = "step.hasCompletedTenantSetupTour",
  HAS_VIEWED_TENANT_SETUP_POST_TOUR = "step.hasViewedTenantSetupPostTour",
  HAS_COMPLETED_RECOGNITION_WELCOME_TOUR = "step.recognition",
  HAS_SEEN_APP_RATING_PROMPT = "step.hasSeenAppStoreRatingPrompt",
  HAS_SEEN_PUSH_NOTIFICATION_PROMPT = "step.hasSeenPushNotificationPrompt",
  HAS_COMPLETED_ADMIN_TOUR = "step.hasCompletedAdminTour",
  HAS_DISMISSED_LINK_CARD_BANNER = "step.hasDismissedLinkCardBanner",
  HAS_DISMISSED_CUSTOM_CATEGORIES_BANNER = "step.hasDismissedCustomCategoriesBanner",
  HAS_VIEWED_WELLNESS_ONBOARDING = "step.hasViewedWellnessOnboarding",
  HAS_VIEWED_FLEXI_POINTS_ONBOARDING = "step.hasViewedFlexiPointsOnboarding",
  HAS_VIEWED_FLEXI_POINTS_ONBOARDING_RETRIGGERED = "step.hasViewedFlexiPointsOnboardingRetriggered",
  HAS_DISMISSED_IE11_DEPRECATION = "step.hasDimissedIE11Warning",
  HAS_HIDDEN_INTEGRATIONS_MODULE = "step.hasHiddenIntegrationsModule",
  HAS_VIEWED_FLEXI_REWARDS_ADMIN_ONBOARDING = "step.hasViewedFlexiRewardsAdminOnboarding",
  HAS_VIEWED_FLEXI_REWARDS_MANAGER_ONBOARDING = "step.hasViewedFlexiRewardsManagerOnboarding",
  HAS_DISMISSED_GLOBAL_MODAL = "step.hasDismissedGlobalModal",
  HAS_COMPLETED_GLOBAL_MODAL = "step.hasCompletedGlobalModal",
  HAS_VIEWED_ADMIN_NAV_ONBORDING = "step.hasViewedAdminNavOnboarding",
  HAS_SEEN_FLEXI_POINTS_BANNNER = "step.hasSeenFlexiPointsBanner",
  HAS_SPENT_ALL_FLEXI_POINTS = "step.hasSpentAllFlexiPoints",
  HAS_SEEN_NEW_REWARDS_POPUP = "step.hasSeenNewRewardsPopup"
}

export default OnboardingSteps
